angular
    .module('app')
    .directive('inlineTariffLimitation', function($rootScope, $filter, $translate){
        return {
            restrict: 'E',
	      	scope: {
		        blockText: '=',
		        blockButton: '=',
                blockContext: '=',
		        layout: '=',
	      	},
            link: function(scope) {

                scope.onSendMessageToIncust = function () {
                    var name    =   $rootScope.USER.name  ? $rootScope.USER.name  + ', ' : '',
                        login   =   $rootScope.USER.login ? $rootScope.USER.login + '\n' : '',
                        msg     =   name +
                                    login + 
                                    $filter('translate')('TEXT_TARIFF_REQUEST_MESSAGE', {entity: scope.blockContext});
                                    //$filter('translate')('TEXT_TARIFF_REQUEST_SUBJECT') + '\n' +

                    $rootScope.onSendMessageToIncust(msg);
                }

                $rootScope.$watch('LANG', function(newValue, oldValue) {
                    scope.LANG = $rootScope.LANG;
                    scope.blockContext = $filter('translate')(scope.blockContext);
                });

                // $rootScope.$watch('USER', function(newValue, oldValue) {
                //     scope.USER = $rootScope.USER;
                // });

            	scope.getLangULR = getLocalizedPathFromLang;
            },
	        template:   '<div ng-if="!layout" class="row">'+
	        				'<div class="col-xs-12">' + 
	        					'<div class="note note-info">' +
							        '<p class="margin-bottom-10 bold" translate> {{blockText}} </p>' +
								    '<p>' +
                                        '<a href ng-click="onSendMessageToIncust()" target="_blank" class="btn btn-sm green-jungle" translate>' +
                                            '{{blockButton}}' +
                                        '</a>' +
								    '</p>' + 
								'</div>' +
	        				'</div>' + 
	        			'</div>' +
                        '<div ng-if="layout==\'compact\'" class="small bold margin-bottom-10">' +
                        	'<span class="small font-blue-dark"><span translate> {{blockText}} </span> ' +
                            '<a href ng-click="onSendMessageToIncust()" class="link" translate> {{blockButton}} </a></span>' +
                        '</div>'
            }
    })